import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, from, mergeMap, take } from 'rxjs';
import { environment } from 'src/environments/environment';

import { FirebaseAuthenticationService } from '../services/firebase/firebase-authentication/firebase-authentication.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(private authService: FirebaseAuthenticationService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    // Only add authorization header for requests to our internal API
    const isInternalApiRequest = req.url.startsWith(environment.api.serverUrl);

    if (!isInternalApiRequest) {
      // For external APIs (like Google Maps), don't add authorization header
      return next.handle(req);
    }

    return this.authService.currentUser$.pipe(
      take(1),
      mergeMap(user => {
        if (user) {
          return from(
            this.authService.getIdToken({ forceRefresh: false }),
          ).pipe(
            mergeMap(data => {
              if (data?.token) {
                const clonedRequest = req.clone({
                  headers: req.headers.set(
                    'Authorization',
                    `Bearer ${data.token}`,
                  ),
                });
                return next.handle(clonedRequest);
              }
              return next.handle(req);
            }),
          );
        } else {
          return next.handle(req);
        }
      }),
    );
  }
}
